import omit from 'lodash/omit';
import { prepareFormToSubmit } from 'UI/utils/forms';

import {
  getCandidateRecruitersOptions,
  getDefaultCandidateRecruiter
} from '../../shared/CandidateDetailsFields/CandidateDetailsFields.utils';
import { resolveDeclinationStatus } from '../DeclinationReasonsDrawer/DeclinationReasons.shared';

import { FORM_FIELDS_MAP } from './SendoutDetailsEditForm.constants';

const buildAccountableRecruiterOption = (accountable = null) => {
  if (!accountable) return null;

  return {
    id: accountable.id,
    full_name: accountable.personalInformation?.full_name
  };
};

const findOptionById = (options = [], optionId = null) => {
  if (optionId == null) return null;

  return options.find(option => option?.id === optionId) || null;
};

export const getSendoutDetailsEditCandidateRecruiterOptions = candidate => {
  const defaultRecruiter = getDefaultCandidateRecruiter(candidate);
  const recruiterOptions = getCandidateRecruitersOptions(candidate);

  if (!defaultRecruiter) return recruiterOptions;
  if (!recruiterOptions.length) return [defaultRecruiter];
  if (recruiterOptions.some(option => option?.id === defaultRecruiter.id)) return recruiterOptions;

  return [defaultRecruiter, ...recruiterOptions];
};

export const buildSendoutDetailsEditDefaultValues = ({
  sendout = null,
  jobOrder = null,
  candidate = null
}) => {
  const candidateRecruiterOptions = getSendoutDetailsEditCandidateRecruiterOptions(candidate);
  const hiringAuthorities = jobOrder?.hiringAuthorities || [];

  return {
    [FORM_FIELDS_MAP.Status.key]: sendout?.status || null,
    [FORM_FIELDS_MAP.EstimatedFeeAmount.key]: sendout?.fee_amount ?? '',
    [FORM_FIELDS_MAP.AccountableRecruiter.key]: buildAccountableRecruiterOption(
      sendout?.jobOrderAccountable
    ),
    [FORM_FIELDS_MAP.CandidateRecruiter.key]: findOptionById(
      candidateRecruiterOptions,
      sendout?.candidate_accountable_id
    ),
    [FORM_FIELDS_MAP.HiringAuthority.key]: findOptionById(
      hiringAuthorities,
      sendout?.hiring_authority_id
    ),
    [FORM_FIELDS_MAP.DeclinationDetails.key]: sendout?.declination_details || null
  };
};

export const isDeclinationStatus = statusId => Boolean(resolveDeclinationStatus(statusId));

export const buildSendoutDetailsEditPayload = formData => {
  const payload = prepareFormToSubmit(formData, omit(FORM_FIELDS_MAP, ['DeclinationDetails']));

  if (!isDeclinationStatus(payload.status_id)) {
    return {
      ...payload,
      declination_details: {
        declined_fields: null, // TODO: current api does not clean the declination_details when status is changed to non-declination status
        declination_notes: ''
      }
    };
  }

  return {
    ...payload,
    declination_details: formData?.[FORM_FIELDS_MAP.DeclinationDetails.key] || null
  };
};
